import React from 'react';
import styled from 'styled-components';
import { spaces } from '../../lib/styles';
import Paragraph from '../Paragraph';
import DisplayName from '../DisplayName';

interface Props {
    avatar: React.ReactNode;
    name: string;
    role: string;
}

const StyledAvatarWithRole = styled.div`
    display: flex;
    align-items: center;
`;

const AvatarWrapper = styled.div`
    margin-right: ${spaces.space5}px;
`;

export default function AvatarWithRole({ avatar, name, role }: Props) {
    return (
        <StyledAvatarWithRole>
            <AvatarWrapper>{avatar}</AvatarWrapper>
            <div>
                <DisplayName>{name}</DisplayName>
                <Paragraph variations={['soft', 'small', 'no-margin']}>{role}</Paragraph>
            </div>
        </StyledAvatarWithRole>
    );
}
